import * as R from 'ramda';

const updatePlacementBoundingBox = store => async (
    state,
    { rhId, plId, exId, boxes },
) => {
    const userClientId = state.user.selectedUserClientId;
    const rightsholders =
        state.clients[userClientId].settings.client.onboarding.rightsholders;
    const rhIndex = rightsholders.findIndex(rh => rh.id === rhId);
    const placements = rightsholders[rhIndex].placements;
    const plIndex = placements.findIndex(pl => pl.id === plId);
    const examples = placements[plIndex].examples;
    const exIndex = examples.findIndex(ex => ex.id === exId);

    const example = { ...examples[exIndex], boundingBoxes: boxes };

    const exampleLens = R.lensPath([
        'clients',
        userClientId,
        'settings',
        'client',
        'onboarding',
        'rightsholders',
        rhIndex,
        'placements',
        plIndex,
        'examples',
        exIndex,
    ]);

    store.setState(R.set(exampleLens, example, store.getState()), true);
};

export default updatePlacementBoundingBox;
